import { atom } from "recoil";
import { persistAtom } from "./persist";

const defaultOauthState = {
  expiry: 0,
  referrer: "",
  route: "",
  path: "",
  flow: "",
  errorMessage: "",
  successMessage: "",
  errorType: "",
  randomBlob: "",
};
export const AllstarOauthState = atom<typeof defaultOauthState>({
  key: "AllstarOauthState_v0.1",
  default: defaultOauthState,
  effects_UNSTABLE: [persistAtom],
});
